/**
 * 共用接口文档地址
 */

import api from "./axiosApi";

const apiList = {
  // 获取当前登录人的菜单权限
  getAuthMenu(data) {
    return api(
      {
        url: "/authority/resource",
        method: "get"
      },
      data || {}
    );
  },
  // 文章数量
  postCount(data) {
    return api(
      {
        url: "/biz/post/postCount",
        method: "post"
      },
      data || {}
    );
  },
  // 生成id
  generateId(data) {
    return api(
      {
        url: "/biz/system/common/generateId",
        method: "get"
      },
      data || {}
    );
  },
  // 查询附件
  getAttachment(data) {
    return api(
      {
        url: "/authority/attachment",
        method: "get"
      },
      data || {}
    );
  },
  // 删除附件
  deleteAttachment(data) {
    return api(
      {
        url: "/authority/attachment",
        method: "delete"
      },
      data || {}
    );
  },
  // 下载附件
  downloadAttachment(data) {
    return api(
      {
        url: `/authority/attachment/download`,
        method: "get",
        responseType: "blob",
        timeOut: 300000
      },
      data || {}
    );
  },
  // 根据业务类型/业务id打包下载
  downloadAttachmentBiz(data) {
    return api(
      {
        url: `/authority/attachment/download/biz`,
        method: "get",
        responseType: "blob",
        timeOut: 300000
      },
      data || {}
    );
  },
  // 获取突击队列表
  commandosList(data) {
    return api(
      {
        url: "/biz/activity/page",
        method: "post"
      },
      data || {}
    );
  },
  // 数据字典
  dictionaryItemList(data) {
    return api(
      {
        url: "/authority/dictionaryItem/mapFromDto",
        method: "post"
      },
      data || {}
    );
  },
  // 修改密码
  updatePassword(data) {
    return api(
      {
        url: "/authority/emp/updatePassword",
        method: "post"
      },
      data || {}
    );
  },
  // 首页--通知列表
  noticePageInfo(data) {
    return api(
      {
        url: "/biz/notice/pageInfo",
        method: "post"
      },
      data || {}
    );
  },
  // 首页--通知标记已读
  noticeUpdateBatch(data) {
    return api(
      {
        url: "/biz/notice/updateBatch",
        method: "post"
      },
      data || {}
    );
  },
  // 是否需要更改密码
  needChanged(data) {
    return api(
      {
        url: "authority/emp/needChanged",
        method: "post"
      },
      data || {}
    );
  },
  // wx
  wxSign(data) {
    return api(
      {
        url: "/biz/wx/sign",
        method: "get",
        baseURL: "/llf"
      },
      data || {}
    );
  }
};
const comApiList = { ...apiList };

export default comApiList;
